export const NO_APP_CHROME_ROUTES = [
  "/login",
  "/signup",
  "/forgot-password",
  "/landing",
  "/about",
  "/privacy",
  "/terms",
  "/refund",
  "/contact",
  "/ai-usage",
  "/disclaimer",
];
